<template>
	<div class="flex flex-wrap items-center bg-red-100 p-2 text-red-600">
		<i-gg-close-o class="mr-2 size-4" />
		<slot />
	</div>
</template>
